import { render, staticRenderFns } from "./CatalogRow.vue?vue&type=template&id=86fe0c2a&scoped=true&"
import script from "./CatalogRow.vue?vue&type=script&lang=js&"
export * from "./CatalogRow.vue?vue&type=script&lang=js&"
import style0 from "./CatalogRow.vue?vue&type=style&index=0&id=86fe0c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fe0c2a",
  null
  
)

export default component.exports